import { useEffect } from 'react';

import { TextNode } from 'lexical';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';

import { formatFaxLineValue } from './faxNumberFormatting';

export function FaxNumberFormattingPlugin() {
  const [editor] = useLexicalComposerContext();

  useEffect(() => editor.registerNodeTransform(TextNode, formatFaxLineValue), [editor]);

  return null;
}
